/**
 * Validation du numéro de formule SIV (certificat d'immatriculation).
 *
 * Format officiel : année d'édition (TOUJOURS "20xx" — le SIV existe depuis 2009,
 * aucune CG n'en porte avant) + 2 lettres + série de chiffres (5 officiellement ;
 * on tolère 4 à 8 par prudence OCR, cf. "2024BX0552046"). Ex : "2014AB12345".
 *
 * Le préfixe "20" est le discriminant clé : il rejette les valeurs aberrantes lues
 * par l'OCR sur une autre zone de la carte grise (ex. "F2AX28QT2HZAA0518", cas
 * GH-828-XX). Partagé par le cross-check (alerte « demander le verso ») ET le
 * mapping de création (on ne pousse JAMAIS un n° hors format vers MiSIV).
 */
export const NUMERO_FORMULE_SIV = /^20\d{2}[A-Z]{2}\d{4,8}$/;

/** Normalise (trim + majuscules) puis teste le format SIV. */
export const isValidNumeroFormule = (raw: unknown): boolean =>
  NUMERO_FORMULE_SIV.test(String(raw ?? '').replace(/\s+/g, '').toUpperCase());
